import React from 'react';
import PropTypes from 'prop-types';
import Message from './Message';
import '../chat-css/MessageList.css';
import {convertFormBackendDate, sameDay} from '../../../../../utils/General';
import Input from "../../../../../components-new/Input";
import TranslateProperty from "../../../../../components/TranslateProperty";
import Translate from "../../../../../components/Translate";
import Audio from "../../../../../assets/images/audio.png";
import Files from "../../../../../assets/images/ticket.png";
import ChatIcon from "../../../../../assets/SelectChatIcon";
import TypingIndicator from "../../../../../components-new/TypingIndicator";


class MessageList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sentMessages: [],
            newMessages: [],
            isAtBottom: true,
            newMessageCount: 0,
            lastMessageDate: null,
            searchTerm: '',
            searchResults: [],
            currentSearchIndex: 0,
            timeline: [],
            activeTab: 'PHOTO',
        };
        this.bottomDiv = React.createRef();
        this.messageWindow = React.createRef();
        this.dateRefs = {};
        this.searchInputRef = React.createRef();
    }

    componentDidMount() {
        const {messages} = this.props;
        if (messages.length > 0) {
            const lastMessage = messages[messages.length - 1];
            this.setState({lastMessageDate: lastMessage.date});
        }

        if (this.state.isAtBottom) {
            this.bottomDiv.current.scrollIntoView();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {messages} = this.props;
        const {messages: oldMessages} = prevProps;

        const prevLastMessage = oldMessages[oldMessages.length - 1];
        const currentLastMessage = messages[messages.length - 1];

        if (oldMessages.length !== messages.length) {
            const newSentMessages = messages.filter(
                msg => msg.sender === "self" && !oldMessages.some(oldMsg => oldMsg.id === msg.id)
            );

            const newReceivedMessages = messages.filter(msg => {
                const isNew = msg.sender !== "self" &&
                    !oldMessages.some(oldMsg => oldMsg.id === msg.id) &&
                    (!this.state.lastMessageDate || new Date(msg.date) > new Date(this.state.lastMessageDate));
                return isNew;
            });

            this.setState(prevState => ({
                sentMessages: [...prevState.sentMessages, ...newSentMessages],
                newMessages: [...prevState.newMessages, ...newReceivedMessages],
                newMessageCount: prevState.isAtBottom ? 0 : prevState.newMessageCount + newReceivedMessages.length,
                lastMessageDate: this.state.isAtBottom && currentLastMessage ? currentLastMessage.date : prevState.lastMessageDate,
            }), () => {
                if (this.state.isAtBottom) {
                    this.bottomDiv.current.scrollIntoView({behavior: 'smooth'});
                }
            });
        }

        const {windowHeight} = snapshot;
        const updatedWindowHeight = this.messageWindow.current.scrollHeight;

        if (oldMessages.length > 0 && messages.length > 0 && oldMessages[oldMessages.length - 1].id !== messages[messages.length - 1].id) {
            if (this.state.isAtBottom) {
                this.messageWindow.current.scrollTop = updatedWindowHeight - windowHeight;
            }
        }

        if (oldMessages.length === 0 || (messages.length > 0 && oldMessages.length > 0 && messages[0].id !== oldMessages[0].id)) {
            if (this.state.isAtBottom) {
                this.bottomDiv.current.scrollIntoView();
            }
        }

        if (!prevProps.showSearchDiv && this.props.showSearchDiv) {
            if (this.searchInputRef.current) {
                this.searchInputRef.current.focus();
            }
        }
    }

    getSnapshotBeforeUpdate(prevProps, prevState) {
        const windowHeight = this.messageWindow.current.scrollHeight;
        return {windowHeight};
    }

    handleScroll = () => {
        const {messagesTotalNumber, messages, loadingOlderMessages, loadOlderMessages} = this.props;

        if (messagesTotalNumber > messages.length && !loadingOlderMessages) {
            if (this.messageWindow.current.scrollTop < 25) {
                loadOlderMessages();
            }
        }

        const isAtBottom = Math.abs(
            this.messageWindow.current.scrollHeight -
            this.messageWindow.current.scrollTop -
            this.messageWindow.current.clientHeight
        ) < 10;

        if (isAtBottom && this.state.newMessageCount > 0) {
            this.scrollToBottom();
        } else {
            this.setState({isAtBottom});
        }
    };

    scrollToBottom = () => {
        this.bottomDiv.current.scrollIntoView();
        this.setState({newMessageCount: 0});
    };

    scrollToSearchResult = (resultIndex) => {
        const result = this.state.searchResults[resultIndex];
        if (result && this.dateRefs[result.id] && this.dateRefs[result.id].current) {
            this.dateRefs[result.id].current.scrollIntoView({behavior: 'smooth', block: 'center'});
        }
    };

    handleSearch = (e) => {
        const searchTerm = e.target.value.toLowerCase();

        if (!searchTerm) {
            this.setState({
                searchTerm: '',
                searchResults: [],
                currentSearchIndex: 0
            }, () => this.scrollToBottom());
            return;
        }

        const searchResults = [];

        this.props.messages.forEach((msg, index) => {
            if (msg.text && msg.text.toLowerCase().includes(searchTerm)) {
                searchResults.push({id: msg.id, index});
            }
        });

        this.setState({
            searchTerm,
            searchResults,
            currentSearchIndex: 0
        }, () => {
            if (searchResults.length > 0) {
                this.scrollToSearchResult(0);
            }
        });
    };

    handleNextSearch = () => {
        const {currentSearchIndex, searchResults} = this.state;
        if (searchResults.length === 0) return;

        const nextIndex = (currentSearchIndex + 1) % searchResults.length;
        this.setState({currentSearchIndex: nextIndex}, () => {
            this.scrollToSearchResult(nextIndex);
        });
    };

    handlePreviousSearch = () => {
        const {currentSearchIndex, searchResults} = this.state;
        if (searchResults.length === 0) return;

        const prevIndex = (currentSearchIndex - 1 + searchResults.length) % searchResults.length;
        this.setState({currentSearchIndex: prevIndex}, () => {
            this.scrollToSearchResult(prevIndex);
        });
    };

    scrollToMessageById = (id) => {
        const ref = this.dateRefs[id];
        if (ref && ref.current) {
            ref.current.scrollIntoView({behavior: 'smooth', block: 'center'});
        }
    };

    render() {
        let {
            messages,
            openImageViewer,
            user,
            messagesTotalNumber,
            showSearchDiv,
            showMediaViewDiv,
            conversation,
            templates,
            updateTemplates,
            readOnly,
            company
        } = this.props;
        const {sentMessages, newMessages, newMessageCount, timeline} = this.state;

        const displayedMessages = messages;
        const reversedMessages = [...displayedMessages].reverse();

        reversedMessages.forEach((message, index, arr) => {
            let displayTimeLine = false;
            if (index === 0) {
                displayTimeLine = messagesTotalNumber <= messages.length;
            } else {
                const prevMessage = arr[index - 1];
                displayTimeLine = !sameDay(convertFormBackendDate(message.date), convertFormBackendDate(prevMessage.date));
            }

            if (displayTimeLine) {
                timeline.push({date: message.createdAt, id: message.id});
            }
        });

        const uniqueTimeline = timeline.filter((item, index, self) =>
            index === self.findIndex(t => t.id === item.id && t.date === item.date)
        );

        return (
            <div style={{height: '100%', display: 'flex', gap: '8px'}}>
                <div key={conversation.id + "_sd"}
                     className="messages-window"
                     ref={this.messageWindow}
                     onScroll={this.handleScroll}
                     style={{
                         position: 'relative',
                         overflowY: 'scroll',
                         paddingRight: '15px',
                         width: '100%'
                     }}
                >
                    <div
                        style={{
                            height: '50px',
                            display: messagesTotalNumber > messages.length ? 'block' : 'none',
                        }}
                    />
                    {reversedMessages.map((message, index, arr) => {
                        let displayTimeLine = false;
                        if (index === 0) {
                            displayTimeLine = messagesTotalNumber <= messages.length;
                        } else {
                            const prevMessage = arr[index - 1];
                            displayTimeLine = !sameDay(convertFormBackendDate(message.date), convertFormBackendDate(prevMessage.date));
                        }

                        const isSent = message.sender === "self";
                        const isMessageSent = sentMessages.includes(message);
                        const isNewMessage = newMessages.includes(message);

                        if (!this.dateRefs[message.id]) {
                            this.dateRefs[message.id] = React.createRef();
                        }

                        const currentHighlightedId = this.state.searchResults[this.state.currentSearchIndex] ? this.state.searchResults[this.state.currentSearchIndex].id : '';
                        const isHighlighted = message.id === currentHighlightedId;

                        return (
                            <div key={message.id + "_sd"} ref={this.dateRefs[message.id]}
                            >
                                <Message
                                    childRef={this.props.childRef} // MessageInput ref
                                    setReplyTo={this.props.setReplyTo}
                                    replyTo={this.props.replyTo}
                                    company={company}
                                    templates={templates}
                                    updateTemplates={updateTemplates}
                                    conversation={conversation}
                                    key={message.id + "_"}
                                    message={message}
                                    openImageViewer={openImageViewer}
                                    displayTimeLine={displayTimeLine}
                                    user={user}
                                    isSent={isSent}
                                    isMessageSent={isMessageSent}
                                    isNewMessage={isNewMessage}
                                    highlight={isHighlighted}
                                />
                            </div>
                        );
                    })}
                    {reversedMessages && reversedMessages.length === 0 && (
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100%',
                            flexDirection: 'column',
                            gap: '10px'
                        }}>
                            <ChatIcon width="130px" height="110px"/>
                            <Translate text={'noMessages'}/>
                        </div>
                    )}
                    <div ref={this.bottomDiv}/>

                    {showSearchDiv && (
                        <div className="message-search"
                             style={readOnly && !window.location.pathname.includes("/chat") ? {
                                 right: '1px',
                                 top: '77px'
                             } : undefined}
                        >
                            <TranslateProperty properties={[{key: 'placeholder', value: 'searchByText'}]}>
                                <Input
                                    ref={this.searchInputRef}
                                    style={{
                                        width: '280px',
                                        height: '35px',
                                    }}
                                    onChange={this.handleSearch}
                                    value={this.state.searchTerm}
                                />
                            </TranslateProperty>

                            {this.state.searchTerm && (
                                <button className="search-clear"
                                        onClick={() => this.handleSearch({target: {value: ''}})}>
                                    ×
                                </button>
                            )}

                            {this.state.searchResults.length > 0 && (
                                <div className="search-nav">
                                    <button className="arrow-btn" onClick={this.handleNextSearch}>↑</button>
                                    <span>{this.state.currentSearchIndex + 1}/{this.state.searchResults.length}</span>
                                    <button className="arrow-btn" onClick={this.handlePreviousSearch}>↓</button>
                                </div>
                            )}

                            {uniqueTimeline.length > 0 && (
                                <select
                                    className="timeline-select"
                                    onChange={(e) => this.scrollToMessageById(e.target.value)}
                                    defaultValue={uniqueTimeline[uniqueTimeline.length - 1].id}
                                >
                                    {uniqueTimeline.map(t => (
                                        <option key={`${t.id}_${t.date}`} value={t.id}>
                                            {new Date(t.date).toLocaleDateString(undefined, {
                                                year: 'numeric',
                                                month: 'short',
                                                day: 'numeric',
                                            })}
                                        </option>
                                    ))}
                                </select>
                            )}


                        </div>
                    )}

                    {showMediaViewDiv && (
                        <div className="file-view"
                             style={readOnly && !window.location.pathname.includes("/chat") ? {
                                 right: '0px',
                                 top: '77px'
                             } : undefined}
                        >
                            <div className="media-tabs">
                                {['PHOTO', 'VIDEO', 'AUDIO', 'FILE'].map(type => {
                                    const count = messages.filter(m => m.type === type).length;
                                    const isActive = this.state.activeTab === type;
                                    return (
                                        <button
                                            key={type}
                                            onClick={() => this.setState({activeTab: type})}
                                            className={`media-tab ${isActive ? 'active' : ''}`}
                                        >
                                            <Translate text={type}/> {isActive && `(${count})`}
                                        </button>
                                    );
                                })}

                            </div>
                            <div className="media-grid">
                                {messages.filter(m => m.type === this.state.activeTab).length > 0 ? (
                                    messages
                                        .filter(m => m.type === this.state.activeTab)
                                        .map((msg) => (
                                            <div
                                                key={`media_${msg.id}`}
                                                className="media-item"
                                                onClick={() => this.scrollToMessageById(msg.id)}
                                            >
                                                {msg.type === 'PHOTO' && <img src={msg.attachment.url} alt="media"/>}
                                                {msg.type === 'VIDEO' && <video src={msg.attachment.url} muted/>}
                                                {msg.type === 'AUDIO' && <div className="file-icon">
                                                    <img style={{height: '25px', width: '25px'}} src={Audio}/>
                                                </div>
                                                }
                                                {msg.type === 'FILE' && (
                                                    <div className="file-icon">
                                                        <img style={{height: '25px', width: '25px'}} src={Files}/>
                                                        <span className="file-extension">
                                                            {msg.attachment.name && (
                                                                msg.attachment.name.split('.').pop()
                                                            )}
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                        ))
                                ) : (
                                    <div className="no-files-message">
                                        <Translate text={'noFilesToDisplay'}/>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {newMessageCount > 0 && (
                        <div className="new-message-count" onClick={this.scrollToBottom}>
                            {newMessageCount}
                            <span className="arrow"> ↓ </span>
                        </div>
                    )}

                    <TypingIndicator messageWindow={this.messageWindow}
                                     conversationId={conversation.id}/>

                </div>

            </div>
        );
    }
}

MessageList.propTypes = {
    messages: PropTypes.array.isRequired,
    user: PropTypes.object.isRequired,
    openImageViewer: PropTypes.func.isRequired,
    messagesTotalNumber: PropTypes.number.isRequired,
    loadOlderMessages: PropTypes.func.isRequired,
    loadingOlderMessages: PropTypes.bool.isRequired,
};

export default MessageList;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/chat/chat-components/MessageList.jsx